(function() {
  'use strict';

  angular
    .module('admin.users.details.items', [])
    .controller('ItemsAdminCtrl', ItemsAdminCtrl);

  /** @ngInject */
  function ItemsAdminCtrl($stateParams, UsersService, EventService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;
    vm.username = $stateParams.username;
    vm.channels = [];
    vm.chId = null;

    function reloadPagination() {
      vm.totalUsers = 0;
      vm.usersPerPage = 25;
      vm.oldPage = 0;
      vm.currentPage = 25;
      vm.first = true;
      vm.totalItems = 0;
      vm.pagination = {
        current: 1
      };
    }

    reloadPagination();

    EventService.listChannels().then(function(result){
      vm.channels = result.results;
    });

    load(1);

    function load(pageNumber){
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }

      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      }
      else {
        vm.first = false;
      }

      var channelId = !vm.chId ? '' : vm.chId;

      UsersService.listItemsExplorer($stateParams.parentId, channelId, vm.oldPage, 25).then(success);

      function success(result){
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }
        for (var i = 0; i < result.results.length; i++) {
          result.results[i].ts = new Date(parseInt(result.results[i].ts.toString().substring(0, result.results[i].ts.toString().length - 3)));
          result.results[i].username = vm.username;
        }
        vm.items = result.results;
      }
    }

    vm.pageChanged = function(newPage) {
      load(newPage);
    };

    vm.search = function(pageNumber){
      reloadPagination();
      load(pageNumber);
    }

    vm.clear = function() {
      vm.chId = null;
      vm.items = [];
      reloadPagination();
      load(1);
    };
  }

})();
